// Comparison

import { ReviewCategory } from "./review";

interface DataPoint {
  id: number;
  carbon: number;
  key: string;
  view: string;
}

interface Column {
  data_points?: DataPoint[];
  start_date: string;
}

interface Comparison {
  columns: Column[];
  months_per_column: number;
}

// Consolidation

interface ConsolidatedReview {
  id?: string;
  company_name: string;
  period_start: string;
  period_end: string;
  carbon: number;
  employees: number;
  turnover: number;
  marketing_segment_id: string;
  review_categories: Array<ReviewCategory>;
  scopes?: Scopes;
  subsidiaries?: Array<Subsidiary>;
}

type Subsidiary = {
  company_name: string;
  carbon: number;
};

type Scopes = { [key in ScopeTypes]: ReviewScopes };

enum ScopeTypes {
  beges = "beges",
  ghg = "ghg_protocol",
}

type ReviewScope = { total: number; [key: string]: number };

type ReviewScopes = {
  [key: string]: ReviewScope;
};

type ScopeData = {
  beges: ScopeDataProtocol;
  ghg_protocol: ScopeDataProtocol;
};

type ScopeDataProtocol = {
  is_ghg_protocol: boolean;
  headers: [string];
  rows: { [scope: string]: ScopeDataRow };
  sum_location_based: number;
  sum_market_based: number;
};

type ScopeDataRow = {
  key: string;
  total_location_based: number;
  co2: number;
  ch4: number;
  n2o: number;
  others: number;
  co2b: number;
  total_market_based: number;
};

export type {
  Column,
  Comparison,
  ConsolidatedReview,
  DataPoint,
  ReviewScope,
  ReviewScopes,
  ScopeData,
  Scopes,
  Subsidiary,
};

export { ScopeTypes };
